import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";

// Same 4-category scheme as the contact panels (matches the standard chart)
const AA_ORDER = [
  "ALA", "CYS", "GLY", "ILE", "LEU", "MET", "PHE", "PRO", "TRP", "VAL",
  "ASN", "GLN", "SER", "THR", "TYR",
  "ARG", "HIS", "LYS",
  "ASP", "GLU",
];

const AA_CATEGORY = {
  ALA: "Non-polar", CYS: "Non-polar", GLY: "Non-polar", ILE: "Non-polar",
  LEU: "Non-polar", MET: "Non-polar", PHE: "Non-polar", PRO: "Non-polar",
  TRP: "Non-polar", VAL: "Non-polar",
  ASN: "Polar", GLN: "Polar", SER: "Polar", THR: "Polar", TYR: "Polar",
  ARG: "Positive", HIS: "Positive", LYS: "Positive",
  ASP: "Negative", GLU: "Negative",
};

const CATEGORY_COLORS = {
  "Non-polar": "#f4d03f",
  "Polar":     "#5dade2",
  "Positive":  "#58d68d",
  "Negative":  "#bb8fce",
};

const CATEGORY_ORDER = ["Non-polar", "Polar", "Positive", "Negative"];

const LigandPocketAAChart = ({ ligandData }) => {
  const [plotData, setPlotData] = useState([]);
  const [layout, setLayout] = useState({});

  useEffect(() => {

    if (!Array.isArray(ligandData) || ligandData.length === 0) {
      setPlotData([]);
      return;
    }

    // Count AA occurrences in the binding pocket.
    // details format: "A/123/CB/LEU | LIG/.../HET"  — only the first half is a residue
    const counts = {};
    AA_ORDER.forEach((aa) => { counts[aa] = 0; });

    ligandData.forEach((row) => {
      if (!row?.details) return;
      const firstHalf = row.details.split('|')[0]?.trim();
      const tokens = firstHalf?.split('/');
      if (tokens && tokens.length >= 4) {
        const aa = tokens[3].trim().toUpperCase();
        if (aa in counts) counts[aa] += 1;
      }
    });

    // One trace per category for a clean clickable legend
    const traces = CATEGORY_ORDER.map((category) => {
      const yValues = AA_ORDER.map((aa) =>
        AA_CATEGORY[aa] === category ? counts[aa] : null
      );
      return {
        x: AA_ORDER,
        y: yValues,
        name: category,
        type: "bar",
        hovertemplate: `Residue: %{x}<br>Count: %{y}<br>Category: ${category}<extra></extra>`,
        marker: {
          color: CATEGORY_COLORS[category],
          line: { color: "#333", width: 0.5 },
        },
      };
    });

    setPlotData(traces);

    setLayout({
      autosize: true,
       font: { size: 9 },
      title: { text: "Binding Pocket Composition" },
      xaxis: {
        type: "category",
        categoryorder: "array",
        categoryarray: AA_ORDER,
        title: { text: "Amino acid" },
        tickangle: -45,
      },
      yaxis: {
        title: { text: "# of contacts with ligands" },
      },
      barmode: "overlay",
      showlegend: true,
      legend: {
        title: { text: "Category" },
        orientation: "v",
        x: 1.02,
        y: 1,
      },
      margin: { t: 50, b: 80, l: 60, r: 80 },
    });
  }, [ligandData]);

  return (
    <div className="aspect-square card">
      <Plot
        data={plotData}
        layout={layout}
        useResizeHandler
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
};

export default LigandPocketAAChart;
